// Angular
import { Component, OnInit } from "@angular/core";
// Services
// External
import { ApiService } from "./../../services/api";

import * as lodash from "lodash";
import { OAuthService } from "./../../services/o-auth";

@Component({
  templateUrl: "./followers.component.html",
})
export class FollowersComponent implements OnInit {
  public query: string;
  public filterArg: any;
  public club: any;
  public users: Array<any>;

  public pageSize: number;
  public imageLoader: boolean = true;

  constructor(
    private apiService: ApiService,
    private oAuthService: OAuthService
  ) {
    this.pageSize = 30;
    this.query = "";
    this.filterArg = {
      fullName: "",
    };
    this.club = this.oAuthService.getClub();
  }

  ngOnInit() {
    this.apiService
      .object(`/user-followers/${this.club.cid}`)
      .then((result) => {
        if (result && result.count > 0) {
          this.users = [];
          lodash.forEach(result.followers, (item, key) => {
            if (item) {
              this.apiService.object(`/users/${key}`).then(
                (result1) => {
                  this.users.push(result1);
                  // console.log(result);
                },
                (error) => {
                  console.error(error);
                }
              );
            }
          });
        }
        this.imageLoader = false;
      });
  }
  public activate(item) {
    if (confirm("Are you sure,you want to Activate the user?")) {
      if (item.isBlock) {
        console.log(item);

        this.apiService
          .set(`/users/${item.$key}/isBlock`, false)
          .then(() => {
            // this.goToPage(this.currentPage);
            item.isBlock = false;
          })
          .catch((error) => {
            console.error(error);
          });
      }
    }
  }

  public deactivate(item) {
    if (confirm("Are you sure,you want to Deactivate the user?")) {
      if (!item.isBlock) {
        console.log(item);

        this.apiService
          .set(`/users/${item.$key}/isBlock`, true)
          .then(() => {
            // this.goToPage(this.currentPage);
            item.isBlock = true;
          })
          .catch((error) => {
            console.error(error);
          });
      }
    }
  }
}
